(() => {
  let scheduled = false;
  const events = ['pointerup', 'keyup', 'scroll'];
  const start = () => {
    if (document.getElementById('merchantWidgetScript')) return;
    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.async = true;
    script.addEventListener('load', () => {
      if (window.merchantwidget) window.merchantwidget.start({
        position: 'LEFT_BOTTOM', sideMargin: 36, bottomMargin: 36,
        mobileSideMargin: 16, mobileBottomMargin: 46, merchant_id: '5357916003'
      });
    }, { once: true });
    document.head.appendChild(script);
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
    else window.setTimeout(start, 0);
  };
  const onInteraction = () => {
    if (scheduled) return;
    scheduled = true;
    events.forEach(type => window.removeEventListener(type, onInteraction));
    schedule();
  };
  events.forEach(type => window.addEventListener(type, onInteraction, { passive: true }));
})();